import { Component } from '@angular/core';

@Component({
  selector: 'od-svg-spinner',
  templateUrl: 'svg-spinner.component.svg',
  styleUrls: ['./svg-spinner.component.scss'],
})
export class SvgSpinnerComponent {
  constructor() {}
}
